export enum FaultStateEnum {
    None = 0,
    InProgress = 1,
    Error = 3
}